export default {  

  props: {    
    overlapAppHeader: { type: Boolean },
    embeddedAppPage: { type: Boolean },
    inline: { type: Boolean },

    showHeader: { type: Boolean, default: true },
    showFooter: { type: Boolean, default: true },
    dockedFooter: { type: Boolean },

    textured: { type: Boolean },
    patternBg: { type: Boolean },
    padding: { type: Boolean, default: true },
    hasFab: { type: Boolean },
  },

  computed: {
    
    classes () {
      return {
        'page': true,

        'page--overlap-app-header': this.overlapAppHeader,
        'page--embedded-app-page': this.embeddedAppPage,
        'page--inline': this.inline,

        'page--with-header': this._displayHeader,
        'page--with-footer': this._displayFooter,
        'page--docked-footer': this.dockedFooter,
        
        'page--textured': this.textured,
        'page--pattern-bg': this.patternBg,
        'page--no-padding': !this.padding,
        'page--with-fab': this.hasFab,
      }
    },

    _displayHeader() {
      return this.showHeader && this.$slots['header'] != null
    },

    _displayFooter() {
      return this.showFooter && this.$slots['footer'] != null
    },
  },

  watch: {
    _displayFooter: {
      immediate: true,
      handler(val) {
        // If a page has a footer, offset any active toasts on screen
        this.$toaster.offsetToastForFooter(val)
      }
    }
  }
}

export const PageFooter = {
  functional: true,

  props: {
    docked: { type: Boolean },
  },

  render: (h, { data, props, children }) => {

    data.staticClass = data.staticClass != null
      ? data.staticClass + ' '
      : ''
      
    const classes = {
      'page__footer': true,
      'page__footer--docked': props.docked,
    }

    data.staticClass += Object.keys(classes).filter(k => classes[k]).join(' ')
    return h('footer', data, children)
  }
}